import { render, staticRenderFns } from "./event-detail.vue?vue&type=template&id=0398c15d&scoped=true&"
import script from "./event-detail.vue?vue&type=script&lang=js&"
export * from "./event-detail.vue?vue&type=script&lang=js&"
import style0 from "./event-detail.vue?vue&type=style&index=0&id=0398c15d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398c15d",
  null
  
)

export default component.exports